import commonScripts from './common';
import stickyHeader from './partials/sticky_header';
import listingApp from './partials/listing';

commonScripts();

if (document.body.classList.contains('page--tag')) {
	stickyHeader(428);
} else {
	stickyHeader('.listing');
}

listingApp();

const desTrunecat = () => {
	const des = document.querySelector('.category__lead');

	if (!des) {
		return;
	}

	const content = des.querySelector('.category__lead-content');
	const contentHeight = content.offsetHeight;
	const lineHeight = parseInt(window.getComputedStyle(content).getPropertyValue('line-height'));
	const maxLines = 4;

	if (contentHeight > (lineHeight * maxLines)) {
		const link = document.createElement('a');

		link.classList.add('category__lead-toggle');
		link.textContent = 'Rozwiń';
		des.appendChild(link)
		content.classList.add('category__lead-content--collapsed')

		link.addEventListener('click', (e) => {
			e.preventDefault();

			if (content.classList.contains('category__lead-content--collapsed')) {
				content.classList.remove('category__lead-content--collapsed');
				link.textContent = 'Zwiń';
			} else {
				content.classList.add('category__lead-content--collapsed')
				link.textContent = 'Rozwiń';
			}
		});
	}

	content.classList.add('category__lead-content--shown')
};
desTrunecat();


// WEBPACK FOOTER //
// ./assets/js/category.js